import { FenceElectricIcon } from './FenceElectricIcon';

/**
 * author: Michael Irigoyen
 * id 9B54CB49-9186-4EB1-80D2-A92E616B9603
 * name fence-electric
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fence-electric.svg
 * tags
 * - Home Automation 
 * - Agriculture 
 */
export const TrainTrackElectricIcon = FenceElectricIcon;
export default TrainTrackElectricIcon